import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Switch,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_PAYMENT_METHOD_DIALOG } from "../../store/paymentMethod/types";

//action
import {
  createPaymentMethod,
  editPaymentMethod,
} from "../../store/paymentMethod/action";

import { permissionError } from "../../util/Alert";

const PaymentMethodDialog = (props) => {
  const dispatch = useDispatch();

  const { dialog: open, dialogData } = useSelector(
    (state) => state.paymentMethod,
  );
  const hasPermission = useSelector((state) => state.admin.admin.flag);

  const [mongoId, setMongoId] = useState("");
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [imageData, setImageData] = useState(null);
  const [imagePath, setImagePath] = useState(null);

  const [errors, setError] = useState({
    name: "",
    code: "",
    isActive: null,
    image: "",
  });

  useEffect(() => {
    if (dialogData) {
      setMongoId(dialogData._id);
      setName(dialogData.name);
      setImagePath(dialogData.image);
      setCode(dialogData.code);
      setIsActive(dialogData.isActive);
    }
  }, [dialogData]);

  useEffect(
    () => () => {
      setError({
        name: "",
        code: "",
        image: "",
        isActive: null,
      });
      setMongoId("");
      setName("");
      setCode("");
      setIsActive(true);
      setImageData(null);
      setImagePath(null);
    },
    [open],
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const HandleInputImage = (e) => {
    if (e.target.files[0]) {
      setImageData(e.target.files[0]);
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImagePath(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const closePopup = () => {
    dispatch({ type: CLOSE_PAYMENT_METHOD_DIALOG });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!code || !name || !mongoId ? !imageData : !imagePath) {
      const errors = {};
      if (!name) errors.name = "Name is Required!";
      if (!code) errors.code = "Code is Required!";
      if (!mongoId) {
        if (!imageData || !imagePath) {
          errors.image = "Image is Required!";
        } else {
          errors.image = "";
        }
      }
      return setError({ ...errors });
    }

    if (!hasPermission) return permissionError();
    const formData = new FormData();

    formData.append("image", imageData);
    formData.append("name", name);
    formData.append("code", code);
    if (isActive === true) {
      formData.append("status", "active");
    } else {
      formData.append("status", "inactive");
    }
    if (mongoId) {
      formData.append("id", mongoId);
      props.editPaymentMethod(mongoId, formData);
    } else {
      props.createPaymentMethod(formData);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="responsive-dialog-title">
          <span className="text-danger font-weight-bold h4">
            {" "}
            Payment Method{" "}
          </span>
        </DialogTitle>

        <IconButton
          style={{
            position: "absolute",
            right: 0,
          }}
        >
          <Tooltip title="Close">
            <Cancel className="text-danger" onClick={closePopup} />
          </Tooltip>
        </IconButton>
        <DialogContent>
          <div className="modal-body pt-1 px-1 pb-3">
            <div className="d-flex flex-column">
              <form>
                <div className="form-group">
                  <label className="mb-2 text-gray">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    required=""
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);

                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          name: "Name is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          name: "",
                        });
                      }
                    }}
                  />
                  {errors.name && (
                    <div className="ml-2 mt-1">
                      {errors.name && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.name}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-group mt-2">
                  <label className="mb-2 text-gray">Code</label>
                  <input
                    type="text"
                    className="form-control"
                    required=""
                    value={code}
                    onChange={(e) => {
                      setCode(e.target.value);

                      if (!e.target.value) {
                        return setError({
                          ...errors,
                          code: "Name is Required!",
                        });
                      } else {
                        return setError({
                          ...errors,
                          code: "",
                        });
                      }
                    }}
                  />
                  {errors.code && (
                    <div className="ml-2 mt-1">
                      {errors.code && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.code}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className="form-group mt-4">
                  <label className="text-gray mb-2">Active</label>

                  <Switch
                    checked={isActive}
                    onChange={(event) => setIsActive(event.target.checked)}
                    name="checkedA"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                </div>

                <div className="form-group mt-4">
                  <label className="mb-2 text-gray">Image</label>
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    accept="image/*"
                    required=""
                    onChange={HandleInputImage}
                  />
                  {errors.image && (
                    <div className="ml-2 mt-1">
                      {errors.image && (
                        <div className="pl-1 text__left">
                          <span className="text-red">{errors.image}</span>
                        </div>
                      )}
                    </div>
                  )}
                  {imagePath && (
                    <>
                      <img
                        height="70px"
                        width="70px"
                        alt="app"
                        src={imagePath}
                        style={{
                          boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                          // border: "2px solid #fff",
                          borderRadius: 10,
                          marginTop: 10,
                          float: "left",
                          objectFit: "cover",
                        }}
                      />
                    </>
                  )}
                </div>
                <div className={imagePath ? "mt-5 pt-5" : "mt-5"}>
                  <button
                    type="button"
                    className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                    onClick={closePopup}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-round float__right btn-danger"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, { createPaymentMethod, editPaymentMethod })(
  PaymentMethodDialog,
);
